import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EligibiliteBeneficiaire } from 'src/app/shared/models/eligibiliteBeneficiaire';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class EligibiliteBeneficiaireService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllEligibiliteBeneficiaire(): Observable<EligibiliteBeneficiaire[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.eligibiliteBeneficiaireUrl}/all`,
			'getAllEligibiliteBeneficiaire'
		);
	}

	importEligibiliteBeneficiaire(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'eligibiliteBeneficiaire.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.eligibiliteBeneficiaireUrl}/import`,
			`importEligibiliteBeneficiaire`,
			formData
		);
	}

	getEligibiliteBeneficiaireById(id: number): Observable<EligibiliteBeneficiaire> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.eligibiliteBeneficiaireUrl}/get/${id}`,
			'getEligibiliteBeneficiaireById'
		);
	}

	updateEligibiliteBeneficiaire(eligibiliteBeneficiaire: EligibiliteBeneficiaire): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.eligibiliteBeneficiaireUrl}/update/${eligibiliteBeneficiaire.id}`,
			'updateEligibiliteBeneficiaire',
			eligibiliteBeneficiaire
		);
	}

	addEligibiliteBeneficiaire(eligibiliteBeneficiaire: EligibiliteBeneficiaire): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.eligibiliteBeneficiaireUrl}/add`,
			'addEligibiliteBeneficiaire',
			eligibiliteBeneficiaire
		);
	}

	deleteEligibiliteBeneficiaire(eligibiliteBeneficiaireId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.eligibiliteBeneficiaireUrl}/delete/${eligibiliteBeneficiaireId}`,
			`deleteEligibiliteBeneficiaire`
		);
	}
}
